import { DATA_TEST_IDS } from '../../consts';

export const PROMO_TRIGGER_LABELLED_BY = [
  DATA_TEST_IDS.AUDIO_REPORT_PROMOS_LABEL,
  DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TRIGGER_TITLE,
  DATA_TEST_IDS.AUDIO_REPORT_PROMOS_TRIGGER_COUNT,
].join(' ');
